import { Box, Grid, Typography, useTheme, TextField, Select, MenuItem, Button } from '@mui/material';
import { Level, useControlPanel } from './ControlPanelProvider';
import { useFormik } from "formik"
import * as DeviceApi from "../axios/device"

interface Props {
    level:Level,
    index:number
}

const LevelRow = ({ level, index }: Props) => {

    const { deleteLevel } = useControlPanel();
    const queryParameters = new URLSearchParams(window.location.search)
    const uid = queryParameters.get("uid") || "none"
    
    const formik = useFormik({
		initialValues:{
			...level
		},
		onSubmit:async (values: Level, { setSubmitting }) => {
			setSubmitting(false)
            if(uid != "none")
            await DeviceApi.controlDevice({ uid, reactionTime:values.reactionTime, vibrationPower:values.vibrationPower})
            setSubmitting(true)
		}
	})


    return (
        <Box component={"form"} onSubmit={formik.handleSubmit}>
            <Grid container padding={1}>
                <Grid item md = {1}>
                <Typography>Level { index + 1 }</Typography>
                </Grid>
                <Grid item md = {3}>
                <Box display={"flex"} alignItems={"center"} gap={1}>
                    <TextField 
                        type='number'
                        name='tipAmount.from' 
                        value={formik.values.tipAmount.from} 
                        onChange={formik.handleChange} 
                        size='small' 
                        sx={{ width:"70px"}}
                    />
                    <Typography>to</Typography>
                    <TextField 
                        type='number'
                        name='tipAmount.to' 
                        value={formik.values.tipAmount.to} 
                        onChange={formik.handleChange} 
                        size='small' 
                        sx={{ width:"70px"}}
                    />
                    <Typography>tokens</Typography>
                </Box>
                </Grid>
                <Grid item md = {3}>
                <Box display={"flex"} alignItems={"center"} gap={1}>
                    <TextField 
                        type='number'
                        name='reactionTime' 
                        value={formik.values.reactionTime} 
                        onChange={formik.handleChange} 
                        size='small' 
                        sx={{ width:"70px"}}
                    />
                    <Typography>SECONDS</Typography>
                </Box>
                </Grid>
                <Grid item md = {2}>
                    <Select 
                        name="vibrationPower" 
                        value={formik.values.vibrationPower} 
                        size='small' 
                        sx={{ width:"150px"}} 
                        onChange={formik.handleChange}
                    >
                        <MenuItem value={5}>Low</MenuItem>
                        <MenuItem value={10}>Medium</MenuItem>
                        <MenuItem value={15}>High</MenuItem>
                        <MenuItem value={20}>Ultra High</MenuItem>
                    </Select>
                </Grid>
                <Grid item md = {2}>
                    <Box display={"flex"} gap={2}>
                        <Button variant='contained' sx={{ color:"#fff" }} onClick={()=>deleteLevel(index)}>
                            Delete
                        </Button>
                        <Button variant='contained' sx={{ color:"#fff" }} onClick={()=>formik.submitForm()}>
                            Start
                        </Button>
                    </Box>
                </Grid>
            </Grid>
        </Box>
    )
}

export default LevelRow;